<template>
	<div class="MainBox" @click.stop="SelectActive(-1,$self)">
    <div class="TableHead">
      <ul class="TableHeadLeft">
        <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius" @click="HandleModel(true)"><span class="icon iconfont iconicon-test20"></span>新增知识库</li>
      </ul>
      <ul class="clear"></ul>
    </div>
    
    <div class="TableMain">
      <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>
      <table class="table StripeTable" v-else>
        <thead>
          <tr>
            <th>编号</th>
            <th>知识库名称</th>
            <th>知识库描述</th>
            <th>向量化模型</th>
            <th>是否启用</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody class="TRHoverStyle">
          <tr v-for="(item,index) in datas" v-bind:key="index">
            <td v-text="item.id"></td>
            <td v-text="item.name"></td>
            <td style="max-width: 200px;word-wrap: break-word;" v-text="item.description"></td>
            <td v-text="item.embeddingModel"></td>
            <td>
                <el-switch :active-value="0" :inactive-value="1" v-model="item.status" @change="changeHandle(item)"></el-switch>
            </td>
            <td v-text="item.createTime"></td>
            <td>
              <div class="btnArray">
                <a class="btnStyleTwo btnRadius greenBackColor" @click="HandleModel(true, item)">编辑</a>
                <a class="btnStyleTwo btnRadius orangeBackColor" @click="GoToPage(`Knowledge?id=${item.id}&title=${item.name}`)">文档</a>
                <a class="btnStyleTwo btnRadius redBackColor" @click="deleteHandle(item)">删除</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- 分页器 -->
      <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>

    </div>

    <!-- 生码窗口 -->
    <div class="ModalBox" v-if="ModelShow">
      <div class="ModalMain">
        <div class="ModalMainHead">
          {{FormDatas.id?'编辑':'新增'}}知识库
          <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback" @click="HandleModel(false)"></span>
        </div>
        <div class="ModalMainBox">
          <ul class="FormStyleTwo">
            <li class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle">知识库商户</p>
              <p>
                <p v-if="FormDatas.name"><input v-model="FormDatas.name" placeholder="请输入" disabled /></p>
                <div v-else class="SelectStyle" @click.stop="SelectActive(1,$self)">
                  {{SelectArr[1].datas[SelectArr[1].ix].name}}
                  <ul class="OptionStyleBox" v-if="SelectArr[1].active">
                    <li class='OptionStyleQuery' v-if="SelectArr[1].totalPages > 1" @click.stop><input placeholder="可在此查询内容" v-model="SQueryName" /><a class="OptionStyleQueryBtn" @click.stop="SelectArrQuery(1)">查询</a></li>
                    <ul class="OptionStyleMain">
                      <li class="OptionStyleRow" :class="{OptionStyleRowActive:SelectArr[1].ix == index && !SelectArr[1].isHover}" v-for="(item,index) in SelectArr[1].datas" v-bind:key="index" v-text="item.name" @click="SelectData(1,index)" @mouseover="SelectHover($self,1,true)" @mouseout="SelectHover($self,1,false)"></li>
                      <li class="OptionStyleLoading" @click.stop="SelectArrLoading(1)" v-if="SelectArr[1].totalPages > 1 && SelectArr[1].page < SelectArr[1].totalPages">加载更多</li>
                      <li class="OptionStyleLoading" @click.stop v-if="SelectArr[1].totalPages > 1 && SelectArr[1].page >= SelectArr[1].totalPages">无更多内容</li>
                    </ul>
                  </ul>
                  <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
                </div>
              </p>
            </li>
            <!-- <li class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i>*</i>知识库名称</p>
              <p><input v-model="FormDatas.name" placeholder="请输入" /></p>
            </li> -->
            <li class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle">知识库描述</p>
              <p><input v-model="FormDatas.description" placeholder="请输入" /></p>
            </li>
          </ul>
        </div>
        <div class="ModalMainFoot">
          <div class="ModalMainFootRight btnArray">
            <a class="btnStyleTwo btnRadius grayBackColor" @click="HandleModel(false)" v-text="$t('c.Common.Cancel')"></a>
            <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm()" v-text="$t('c.Common.Confirm')"></a>
          </div>
        </div>
      </div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

	</div>
</template>

<script>
var self,Timeout;
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Confirm from '@/components/common/Confirm.vue'
import Toast from '@/components/common/Toast.vue'
export default {
  name: 'CodeManage',
  components: {
    'K-Paging': Paging,
    'K-Transition': Transition,
    'K-Confirm': Confirm,
    'K-Loading': Loading,
    'K-Toast': Toast
  },
  data () {
    return {
      btype:null,
      tradeType:null,
      $self:null,
      page:1,
      pageSize: 20,
      subHint:'数据加载中...',
      isLoding:true,
      loading:false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      Confirm:{
        state:false,
        txt:null,
        style:1
      },
      totalPages:1,
      datas:null,
      SQueryName:null,
      SelectArr:[{
        ix:0,
        active:false,
        datas:["10位","5位"]
      },{
        ix:0,
        page:1,
        totalPages:0,
        active:false,
        isHover:false,
        datas:[]
      }],
      ModelShow:false,
      defaultFormDatas:{
        id: '',
        name: '',
        description: '',
        tenantId: '',
        embeddingModelId: 2,
        topK: 5,
        similarityThreshold: 0.5,
        status: 0
      },
      FormDatas: {},
      CodeNumber:null,
      id: '',
      headers: {
        'tenant-id': localStorage.getItem("ai_tenantId"),
        'token': localStorage.getItem("ai_Token")
      }
    }
  },
  created () {
    this.$self = this;
    Object.assign(this.FormDatas, this.defaultFormDatas);
    this.btype = localStorage.getItem("wwmxt_BType");  //商户类型
    this.tradeType = localStorage.getItem("wwmxt_TradeType");  //行业类型
    this.GetBusinessList();
  },
  beforeDestroy () {
    clearInterval(Timeout);
  },
  mounted () {
    this.GetList();
  },
  methods: {
    ToastFun (type,txt) {
      this.Toast.state = true;
      this.Toast.type = type;
      this.Toast.txt = txt;
    },
    ChangeToast () {
      this.Toast.state = false;
    },
    ChangePage (data) {  //上下翻页
      if(data.te == 1){
        if(this.page > 1){
          this.page--
        }
      }else{
        if(this.page < this.totalPages){
          this.page++
        }
      }
      this.GetList();
    },
    SkipPage (data) {  //跳转分页
      this.page = data.ix;
      this.GetList();
    },
    SelectData (ix,six) {  //选中选择框内容
      this.SelectArr[ix].ix = six;
      this.SelectArr[ix].isHover = false;
    },
    HandleModel (status, item) {  //隐藏显示生码模态框
      this.ModelShow = status;
      Object.assign(this.FormDatas, item?item:this.defaultFormDatas);
    },
    GetList () {
      this.datas = null;
      this.isLoding = true;
      this.subHint = "数据加载中...";
      axios.post(this.GetAiUrl() + `/ai/knowledge/page`, { pageNo: this.page, pageSize: this.pageSize}, {headers: this.headers})
      .then( (response)=>{
        this.isLoding = false;
        if(response.data.code == 0 && response.data.data.list.length){
          this.datas = response.data.data.list;
          this.totalPages = Math.ceil(response.data.data.total / this.pageSize);  //总页数
        }else{
          this.subHint = "数据为空";
        }
      }).catch( (error)=>{
        this.subHint = this.ErrorHint(error);
        this.isLoding = false;
      })
    },
    GetBusinessList (te) {
      axios.post(this.GetServerUrl(1)+"business_list", {page:this.page})
      .then( (response)=>{
        if(!te){
          this.SelectArr[1].datas = response.data.meta.data;
          this.SelectArr[1].totalPages = response.data.meta.last_page;
        }else{
          this.loading = false;
          let datas = response.data.meta.data;
          for(let item in datas){
            this.SelectArr[1].datas.push(datas[item]);
          }
        }
      }).catch( (error)=>{
        if(!te){
          this.loading = false;
        }
      })
    },
    changeHandle(item){
      Object.assign(this.FormDatas, item);
      this.SubmitForm(true);
    },
    SubmitForm (noRefresh=false){
      let id = '';
      let name = this.SelectArr[1].datas[this.SelectArr[1].ix].name;
      let tenantId = this.SelectArr[1].datas[this.SelectArr[1].ix].rootid;
      delete this.FormDatas.createTime
      let url = this.GetAiUrl() + `/ai/knowledge/create`;
      let method = "POST";
      if(this.FormDatas.id){
        id = this.FormDatas.id;
        name = this.FormDatas.name;
        tenantId = this.FormDatas.tenantId;
        method = "PUT";
        url = this.GetAiUrl() + `/ai/knowledge/update`
      }
      this.loading = true;
      axios({
        method,
        url,
        headers: this.headers,
        data: {...this.FormDatas, id, name, tenantId}
      }).then( (response)=>{
        this.loading = false;
        if(response.data.code == 0){
          this.ToastFun(0, "成功");  //弹窗提醒
          this.HandleModel(false);
          if(!noRefresh){
            this.GetList();
          }
        }else{
          this.ToastFun(2, response.data.msg);  //弹窗提醒
        }
      }).catch(function (error){
        this.loading = false;
        this.ToastFun(2,this.ErrorHint(error));  //弹窗提醒
      })
    },
    deleteHandle(item){
      this.id = item.id;
      this.Confirm.state = true;
      this.Confirm.txt = "是否确定删除该知识文档吗？"
    },
    ConfirmBackFun (data) {
      this.Confirm.state = data.state;
      if(data.state){
        this.Confirm.state = false;
        this.loading = true;
        axios({
          method:"delete",
          url: this.GetAiUrl() + `/ai/knowledge/delete?id=${this.id}`,
          headers: this.headers
        }).then( (response)=> {
            this.loading = false;
            if(response.data.code == 0){
              this.ToastFun(0, "删除成功");  //弹窗提醒
              this.GetList();
            }else{
              this.ToastFun(2, response.data.msg);  //弹窗提醒
            }
        }).catch( (error)=> {
          this.loading = false;
          this.ToastFun(2,this.ErrorHint(error));  //弹窗提醒
        })
      }
    },
    SelectArrQuery (te) {
      this.loading = true;
      axios.post(this.GetServerUrl(1)+"business_list",{name:this.SQueryName})
      .then( (response)=>{
        this.SelectArr[te].ix = 0;
        this.SelectArr[te].datas = response.data.meta.data;
        this.loading = false;
      }).catch( (error)=>{
        this.loading = false;
        this.ToastFun(2,this.ErrorHint(error));  //弹窗提醒
      })
    },
    SelectArrLoading (ix) {
      this.SelectArr[ix].page++;
      this.loading = true;
      this.GetBusinessList(true);
    },
  }
}
</script>

<style scoped>
  .RemainCode{
    display: block;
    color:#FFF;
    font-size:13px;
    margin-top:5px;
    padding: 5px 10px;
    border-radius: 3px;
    background-color: #F77851;
  }
</style>
